'use strict';

var THE_SCRIPT = function () {
    const $onReady = require('public/js/lib/on-ready');

	(function BundleRecommendationModule() {
		$onReady({
			rp$, window,
			label: 'bundle_recommendation',
			fn: function () {
				rp$('.carrousel-selectors').on('click', '.carrousel-selector', function () {
                    const carrouselItem = this.getAttribute('carrousel-item');

                    const carrouselElement = rp$(this);
                    carrouselElement.parent().find('.active').removeClass('active');
                    carrouselElement.addClass('active');

                    const elementToHide = rp$('.carrousel-item').filter('.active');
                    elementToHide.removeClass('active');
                    const elementToShow = rp$(`.carrousel-item[carrousel-item="${carrouselItem}"]`);
                    elementToShow.addClass('active');

				});

				rp$('.bundle-recommendation-module').parent().on('click', '.fitment-more', function HookMoreInfoClick(evt) {
					evt.preventDefault();

					const elementsWithHideClass = rp$(this).parent().find('.hide');
					const elementsWithShowClass = rp$(this).parent().find('.show');
					elementsWithHideClass.addClass('show');
					elementsWithHideClass.removeClass('hide');
					elementsWithShowClass.addClass('hide');
					elementsWithShowClass.removeClass('show');
				});
			},
		});
	})();
};

try {
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
